import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';

function MobileBottomNav({ tabs, basePath, isDark, unreadMessages }) {
    const location = useLocation();

    return (
        <nav
            data-testid="mobile-bottom-nav"
            className="md:hidden fixed bottom-0 left-0 right-0 z-[80] border-t backdrop-blur-xl"
            style={{
                paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                background: isDark ? 'rgba(10,10,26,0.95)' : 'rgba(255,255,255,0.95)',
                borderColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
                pointerEvents: 'auto',
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
            }}
        >
            <div className="flex items-stretch justify-around px-1 py-1">
                {tabs.map((tab) => {
                    const isActive =
                        location.pathname === tab.to ||
                        (tab.to !== basePath && location.pathname.startsWith(tab.to));
                    if (tab.isCreate) {
                        return (
                            <NavLink
                                key={tab.to}
                                to={tab.to}
                                className="flex flex-col items-center justify-end gap-0.5 -mt-4 px-2 active:scale-95 transition-transform"
                                style={{ touchAction: 'manipulation', minHeight: 56 }}
                                data-testid="mobile-create-button"
                            >
                                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#681793] to-[#FF914D] flex items-center justify-center shadow-lg shadow-[#681793]/40 border-2 border-background">
                                    <Plus className="w-6 h-6 text-white" />
                                </div>
                                <span
                                    className={`text-[10px] font-medium ${
                                        isDark ? 'text-white/50' : 'text-slate-500'
                                    }`}
                                >
                                    {tab.label}
                                </span>
                            </NavLink>
                        );
                    }
                    return (
                        <NavLink
                            key={tab.to}
                            to={tab.to}
                            end={tab.to === basePath}
                            data-testid={`mobile-nav-${tab.label.toLowerCase().replace(/\s/g, '-')}`}
                            className="flex flex-col items-center justify-center gap-0.5 px-2 py-2 rounded-xl transition-all flex-1 active:scale-95"
                            style={{ touchAction: 'manipulation', minHeight: 56 }}
                        >
                            {({ isActive: navActive }) => (
                                <>
                                    <div
                                        className={`relative p-1.5 rounded-xl transition-all ${
                                            navActive ? 'bg-purple-500 shadow-lg shadow-purple-500/20' : ''
                                        }`}
                                    >
                                        <tab.icon
                                            className={`w-5 h-5 ${
                                                navActive
                                                    ? 'text-white'
                                                    : isDark
                                                        ? 'text-white/40'
                                                        : 'text-slate-400'
                                            }`}
                                        />
                                        {tab.label === 'Messages' && unreadMessages > 0 && (
                                            <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-[#FF914D] text-white text-[8px] font-bold flex items-center justify-center">
                                                {unreadMessages > 9 ? '9+' : unreadMessages}
                                            </span>
                                        )}
                                    </div>
                                    <span
                                        className={`text-[10px] font-medium ${
                                            navActive
                                                ? isDark
                                                    ? 'text-white'
                                                    : 'text-slate-900'
                                                : isDark
                                                    ? 'text-white/30'
                                                    : 'text-slate-400'
                                        }`}
                                    >
                                        {tab.shortLabel || tab.label}
                                    </span>
                                </>
                            )}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}

export default MobileBottomNav;
